import React from 'react';
import { Empty } from '@tencent/adp-combine-ui';
import TopBottom from 'maker/layouts/topBottom';

const NotFound = (props: any) => <TopBottom {...props}><Empty description="您访问的页面不存在" /></TopBottom>;

export default NotFound;